import { logger } from "@/utils/logger";
import { Module } from "vuex";
import { PicklistState } from "@/types";
import {
    fetchReasons,
    getAccessoryCalculationMethod,
    getAccessoryPaymentDatesOption,
    getAccountStatus,
    getAccountType,
    getActionType,
    getActivityAsset,
    getActivitySector,
    getAddressPreferenceType,
    getAddressType,
    getAssetCatalog,
    getAssetStatut,
    getAssetType,
    getAssetsMock,
    getBaseCalcule,
    getBodiesAsset,
    getBrand,
    getBrandsAsset,
    getCategoriesAsset,
    getChannel,
    getClientStatus,
    getClientType,
    getColorsAsset,
    getContactType,
    getCountries,
    getDecisionMotif,
    getDecisionOpinion,
    getDecisionReserve,
    getDecisionStatus,
    getSupportingDocumentStatus,
    getDelegationLevels,
    getDemandStatus,
    getEmissionsCO2Asset,
    getFacilityType,
    getFinancialInstitution,
    getFinishesAsset,
    getFuelTypesAsset,
    getGarantyBasis,
    getGarantyRules,
    getGarantyStatus,
    getGarantyType,
    getGender,
    getGeographicZone,
    getIdProof,
    getJobActivity,
    getJobOccupationType,
    getJobPositionType,
    getLanguage,
    getLegalCategory,
    getMatrimonialRegime,
    getModelsAsset,
    getModule,
    getNamesServices,
    getNationality,
    getNature,
    getNatureBalanceSheet,
    getOccupation,
    getOrderItemStatus,
    getOrderServiceType,
    //getOrderStatus,
    getOrderTypeFinancing,
    getPartyClass,
    getPartyClassificationType,
    getPartyRelationTypes,
    getPartyRules,
    getPaymentDate,
    getPaymentFrequence,
    getPeriodRateOption,
    getPeriodicity,
    getPicklistInitialValues,
    getPostalCodes,
    getPowersHPAsset,
    getProductAvailabilityContext,
    getProductBasis,
    getProductTax,
    getProductTaxServices,
    getQualificationType,
    getRange,
    getRelationType,
    getRelations,
    getRoleStatus,
    getScaleCategory,
    getScaleClassification,
    getScaleFinancialProfile,
    getScaleGracePeriodCalculationMethod,
    getScaleProductFrequency,
    getScaleRateBasis,
    getScaleStatus,
    getServiceType,
    getSignatureMethods,
    getStatusMarital,
   // getStatusOrderList,
    getTerm,
    getTitles,
    getTypeOutstanding,
    getTypeService,
    getUnderlyingType,
    getUsageAsset,
    getUserSecurityGroup,
    getUserTeam,
    getWarrantMethod,
    getcodeNaceOptions,
    getcontractType,
    getdocumentType,
    getpropertyStatus,
    getroleOrder,
    getuserNetwork,
    getuserNetworkNode,
    getYesorNoOptions,
    getDelegationLevelsSchema, getNetheosStatus,
    getqualificationTypeGroupeOptions,
    getTemplateCode,
} from "@/store/services/picklist";
import Notify from 'quasar/src/plugins/Notify.js';;
import { translateComboBox, translatePicklist } from "@/utils";
import store from "..";
import i18n from "@/i18n";
import { isUnfilteredPostalQuery } from "@/store/services/picklist";

const ODM_PARTY = "odm-party";

const attemptedLazyPicklists = new Set<string>();

function lazyLoadPicklistItems(
  key: string,
  state: PicklistState,
  stateKey: keyof PicklistState,
  fetcher: () => Promise<{ items?: unknown[] } | null | undefined>
): void {
  const current = state[stateKey] as { items?: unknown[] } | undefined;
  if (current?.items?.length) {
    return;
  }
  if (attemptedLazyPicklists.has(key)) {
    return;
  }

  attemptedLazyPicklists.add(key);
  fetcher()
    .then((result) => {
      if (result?.items?.length) {
        (state as Record<string, unknown>)[stateKey as string] = result;
      }
    })
    .catch(() => {
      // Keep key in attempted set to prevent infinite retry loops.
    });
}

const picklistModule: Module<PicklistState, any> = {
  namespaced: true,
  state: {
    postalCodesFullByCountry: {},
    thirdEditPicklistsReady: false,
  },
  getters: {
    financialProfileItems: (state) => {
        lazyLoadPicklistItems("financialProfile", state, "financialProfile", getScaleFinancialProfile);
        return state.financialProfile?.items ?? [];
    },
    scaleStatusItems: (state) => {
        lazyLoadPicklistItems("scaleStatus", state, "scaleStatus", getScaleStatus);
        if (state.scaleStatus?.items) {
            return translateComboBox(state.scaleStatus.items, 'scales.picklist.status');
        } else {
          return [];
        }
    },
    scaleCategoryItems: (state) => {
        lazyLoadPicklistItems("scaleCategory", state, "scaleCategory", getScaleCategory);
        return state.scaleCategory?.items ?? [];
    },
    assetCategoryItems: (state) => {
        lazyLoadPicklistItems("categoryAsset", state, "categoryAsset", getCategoriesAsset);
        return state.categoryAsset?.items ?? [];
    },
    usageAssetItems: (state) => {
        lazyLoadPicklistItems("usageAsset", state, "usageAsset", getUsageAsset);
        return state.usageAsset?.items ?? [];
    },
    colorsList: (state) => {
        lazyLoadPicklistItems("colors", state, "colors", getColorsAsset);
        return state.colors?.items ?? [];
    },
    activityList: (state) => {
        lazyLoadPicklistItems("activity", state, "activity", getActivityAsset);
        return state.activity?.items ?? [];
    },
    productTax: (state) => {
        lazyLoadPicklistItems("productTax", state, "productTax", getProductTax);
        if (state.productTax?.items) {
            return translateComboBox(state.productTax.items, 'picklists.productTaxOptions');
        } else {
          return [];
        }
    },
    productTaxServicesItems: (state) => {
      lazyLoadPicklistItems("productTaxServices", state, "productTaxServices", getProductTaxServices);
      return state.productTaxServices?.items ?? [];
  },
  scaleFrequencyItems: (state) => {
      lazyLoadPicklistItems("scalefrequency", state, "scalefrequency", getScaleProductFrequency);
      return state.scalefrequency?.items ?? [];
  },
  scaleRateBasisItems: (state) => {
      lazyLoadPicklistItems("scaleRateBasis", state, "scaleRateBasis", getScaleRateBasis);
      return state.scaleRateBasis?.items ?? [];
  },
  scaleGracePeriodCalculationMethodItems: (state) => {
      lazyLoadPicklistItems("scaleGracePeriodCalculationMethod", state, "scaleGracePeriodCalculationMethod", getScaleGracePeriodCalculationMethod);
      return state.scaleGracePeriodCalculationMethod?.items ?? [];
  },
  signatureMethodsItems: (state) => {
      lazyLoadPicklistItems("signatureMethods", state, "signatureMethods", getSignatureMethods);
      return state.signatureMethods?.items ?? [];
  },
  serviceTypeItems: (state) => {
      lazyLoadPicklistItems("serviceType", state, "serviceType", getServiceType);
      if (state.serviceType?.items) {
          return translateComboBox(state.serviceType.items, 'scales.picklist.serviceTypes');
      } else {
        return [];
      }
  },
  partyClassificationTypeItems: (state) => {
      lazyLoadPicklistItems("partyClassificationType", state, "partyClassificationType", getPartyClassificationType);
      if (state.partyClassificationType?.items) {
          return translateComboBox(state.partyClassificationType.items, 'picklists.partyClassificationType');
      } else {
        return [];
      }
  },
  productBasisItems: (state) => {
      lazyLoadPicklistItems("productBasis", state, "productBasis", getProductBasis);
      if (state.productBasis?.items) {
          return translateComboBox(state.productBasis.items, 'scales.picklist.productBasis');
      } else {
        return [];
      }
  },
  accessoryCalculationMethodItems: (state) => {
      lazyLoadPicklistItems("accessoryCalculationMethod", state, "accessoryCalculationMethod", getAccessoryCalculationMethod);
      if (state.accessoryCalculationMethod?.items) {
          return translateComboBox(state.accessoryCalculationMethod.items, 'scales.picklist.accessoryCalculationMethod');
      } else {
        return [];
      }
  },
  accessoryPaymentDatesOptionItems: (state) => {
      lazyLoadPicklistItems("accessoryPaymentDatesOption", state, "accessoryPaymentDatesOption", getAccessoryPaymentDatesOption);
      return state.accessoryPaymentDatesOption?.items ?? [];
  },
  assetTypeItems: (state) => {
      lazyLoadPicklistItems("assetTypeItems", state, "assetTypeItems", getAssetType);
      return state.assetTypeItems?.items ?? [];
  },
  assetStatutItems: (state) => {
    lazyLoadPicklistItems("assetStatut", state, "assetStatut", getAssetStatut);
    return state.assetStatut?.items ?? [];
  },
  assetCatalogItems: (state) => {
    lazyLoadPicklistItems("assetCatalog", state, "assetCatalog", getAssetCatalog);
    return state.assetCatalog?.items ?? [];
  },
  getYesorNoOptions: (state) => {
    lazyLoadPicklistItems("yesOrNoOptions", state, "yesOrNoOptions", getYesorNoOptions);
    return state.yesOrNoOptions?.items ?? [];
  },
  garantyStatusItems: (state) => {
    lazyLoadPicklistItems("garantyStatus", state, "garantyStatus", getGarantyStatus);
    if (state.garantyStatus?.items) {
        return translateComboBox(state.garantyStatus.items, 'garanty.garantyFilter.picklist.status');
    } else {
      return [];
    }
  },
  garantyTypeItems: (state) => {
    lazyLoadPicklistItems("garantyType", state, "garantyType", getGarantyType);
    if (state.garantyType?.items) {
        return translateComboBox(state.garantyType.items, 'garanty.garantyFilter.picklist.type');
    } else {
      return [];
    }
  },
  typeOutstandingItems: (state) => {
    lazyLoadPicklistItems("typeOutstanding", state, "typeOutstanding", getTypeOutstanding);
    return state.typeOutstanding?.items ?? [];
  },
  financialInstitutionItems: (state) => {
    lazyLoadPicklistItems("financialInstitution", state, "financialInstitution", getFinancialInstitution);
    return state.financialInstitution?.items ?? [];
  },
  underlyingTypeItems: (state) => {
    lazyLoadPicklistItems("underlyingType", state, "underlyingType", getUnderlyingType);
    return state.underlyingType?.items ?? [];
  },
  garantybasisItems: (state) => {
    lazyLoadPicklistItems("garantyBasis", state, "garantyBasis", getGarantyBasis);
    return state.garantyBasis?.items ?? [];
  },
  genderItems: (state) => {
    lazyLoadPicklistItems("gender", state, "gender", getGender);
    return state.gender?.items ?? [];
  },
  propertyStatusItems: (state) => {
    lazyLoadPicklistItems("propertyStatus", state, "propertyStatus", getpropertyStatus);
    return state.propertyStatus?.items ?? [];
  },
  contractTypeItems: (state) => {
    lazyLoadPicklistItems("contractType", state, "contractType", getcontractType);
    return state.contractType?.items ?? [];
  },
  productAvailabilityContextItems: (state) => {
    lazyLoadPicklistItems("productAvailabilityContext", state, "productAvailabilityContext", getProductAvailabilityContext);
    return state.productAvailabilityContext?.items ?? [];
  },
  roleItems: (state) => {
    lazyLoadPicklistItems("role", state, "role", getPartyRules);
    if (state.role?.items) {
        return translateComboBox(state.role.items, 'demand.party.roles');
    } else {
      return [];
    }
  },
  roleOrderItems: (state) => {
    lazyLoadPicklistItems("roleOrder", state, "roleOrder", getroleOrder);
    if (state.roleOrder?.items) {
        return translateComboBox(state.roleOrder.items, 'demand.party.roles');
    } else {
      return [];
    }
  },
  geographicZoneItems: (state) => {
    lazyLoadPicklistItems("geographicZone", state, "geographicZone", getGeographicZone);
    if (state.geographicZone?.items) {
        return translateComboBox(state.geographicZone.items, 'demand.party.geographicZone');
    } else {
      return [];
    }
  },
  facilityTypeItems: (state) => {
    lazyLoadPicklistItems("facilityType", state, "facilityType", getFacilityType);
    if (state.facilityType?.items) {
        return translateComboBox(state.facilityType.items, 'middleOffice.party.organization.establishments.types');
    } else {
      return [];
    }
  },
  qualificationTypeItems: (state) => {
    lazyLoadPicklistItems("qualificationType", state, "qualificationType", getQualificationType);
    if (state.qualificationType?.items) {
        return translateComboBox(state.qualificationType.items, 'middleOffice.party.organization.contact.fonction');
    } else {
      return [];
    }
  },
  natureItems: (state) => {
    lazyLoadPicklistItems("nature", state, "nature", getNature);
    if (state.nature?.items) {
        return translateComboBox(state.nature.items, 'incomeAndExpenses.type');
    } else {
      return [];
    }
  },
  statusMaritalItems: (state) => {
    lazyLoadPicklistItems("statusMarital", state, "statusMarital", getStatusMarital);
    if (state.statusMarital?.items) {
        return translateComboBox(state.statusMarital.items, 'demand.party.statusMarital');
    } else {
      return [];
    }
  },
  matrimonialRegimeItems: (state) => {
    lazyLoadPicklistItems("matrimonialRegime", state, "matrimonialRegime", getMatrimonialRegime);
    if (state.matrimonialRegime?.items) {
        return translateComboBox(state.matrimonialRegime.items, 'demand.party.regimeMatrimonial');
    } else {
      return [];
    }
  },

    //demand
    demandStatusItems: (state) => {
      lazyLoadPicklistItems("demandStatus", state, "demandStatus", getDemandStatus);
      if (state.demandStatus?.items) {
        return translatePicklist(state.demandStatus.items, 'enum.offer.status');
      } else {
        return [];
      }
    },
    brandItems: (state) => {
      lazyLoadPicklistItems("brand", state, "brand", getBrand);
      return state.brand?.items ?? [];
    },
    clientTypeItems: (state) => {
      lazyLoadPicklistItems("clientType", state, "clientType", getClientType);
      return state.clientType?.items ?? [];
    },
    channelItems: (state) => {
      lazyLoadPicklistItems("channel", state, "channel", getChannel);
      return state.channel?.items ?? [];
    },
    moduleItems: (state) => {
      lazyLoadPicklistItems("module", state, "module", getModule);
      return state.module?.items ?? [];
    },
  /*  orderStatus: (state) => {
      lazyLoadPicklistItems("orderStatus", state, "orderStatus", getOrderStatus);
      if (state.orderStatus?.items) {
        return translateComboBox(state.orderStatus.items, 'order.picklist.status');
      } else {
        return [];
      }
    },*/
    orderItemStatus: (state) => {
      lazyLoadPicklistItems("orderItemStatus", state, "orderItemStatus", getOrderItemStatus);
      return state.orderItemStatus?.items ?? [];
    },
    orderServiceTypeItems: (state) => {
      lazyLoadPicklistItems("orderServiceType", state, "orderServiceType", getOrderServiceType);
      return state.orderServiceType?.items ?? [];
    },
    rangeItems: (state) => {
      lazyLoadPicklistItems("range", state, "range", getRange);
      return state.range?.items ?? [];
    },

    //Decision
    decisionOpinionItems: (state) => {
      lazyLoadPicklistItems("decisionOpinion", state, "decisionOpinion", getDecisionOpinion);
      return state.decisionOpinion?.items ?? [];
  },
  delegationLevelsItems: (state) => {
      lazyLoadPicklistItems("delegationLevels", state, "delegationLevels", getDelegationLevels);
      if (state.delegationLevels?.items) {
        return state.delegationLevels.items
          .filter((item) => !["D.C.T.Y", "A.F.DRI"].includes(item.value))
          .map(item => ({
          value: item.value,
          label: i18n.global.t(`decision.label.${item.label}`)
        }))
          .sort((a, b) => a.label.localeCompare(b.label));
      } else {
        return [];
      }
  },
  delegationLevelsSchemaItems: (state) => {
      lazyLoadPicklistItems("delegationLevelsSchema", state, "delegationLevelsSchema", getDelegationLevelsSchema);
      if (state.delegationLevelsSchema?.items) {
        return state.delegationLevelsSchema.items
      } else {
        return [];
      }
  },
  userSecurityGroupItems: (state) => {
      lazyLoadPicklistItems("userSecurityGroup", state, "userSecurityGroup", getUserSecurityGroup);
      return state.userSecurityGroup?.items ?? [];
  },
 /* statusOrderList: (state) => {
    lazyLoadPicklistItems("statusOrder", state, "statusOrder", getStatusOrderList);
    return state.statusOrder?.items ?? [];
},*/

  userTeamItems: (state) => {
      lazyLoadPicklistItems("userTeam", state, "userTeam", getUserTeam);
      return state.userTeam?.items ?? [];
  },
  userNetwork: (state) => {
      lazyLoadPicklistItems("userNetwork", state, "userNetwork", getuserNetwork);
      return state.userNetwork?.items ?? [];
  },
  userNetworkNode: (state) => {
      lazyLoadPicklistItems("userNetworkNode", state, "userNetworkNode", getuserNetworkNode);
      return state.userNetworkNode?.items ?? [];
  },
  documentTypeItems: (state) => {
      lazyLoadPicklistItems("documentType", state, "documentType", getdocumentType);
      return state.documentType?.items ?? [];
  },
  jobOccupationTypeItems: (state) => {
      lazyLoadPicklistItems("jobOccupationType", state, "jobOccupationType", () => getJobOccupationType([]));
    if (state.jobOccupationType?.items) {
        return translateComboBox(state.jobOccupationType.items, 'picklists.socioProfessionalCode.');
    } else {
      return [];
    }
  },
  codeNaceOptionsItems: (state) => {
    lazyLoadPicklistItems("codeNaceOptions", state, "codeNaceOptions", getcodeNaceOptions);
    if (state.codeNaceOptions?.items) {
        return translateComboBox(state.codeNaceOptions.items, 'picklists.codeNace.');
    } else {
      return [];
    }
  },
  qualificationTypeGroupeOptionsItems: (state) => {
    lazyLoadPicklistItems("qualificationTypeGroupeOptions", state, "qualificationTypeGroupeOptions", getqualificationTypeGroupeOptions);
    if (state.qualificationTypeGroupeOptions?.items) {
        return translateComboBox(state.qualificationTypeGroupeOptions.items, 'picklists.qualificationTypeGroupe.');
    } else {
      return [];
    }
  },
  typeServiceItems: (state) => {
    lazyLoadPicklistItems("typeService", state, "typeService", getTypeService);
    return state.typeService?.items ?? [];
  },
  baseCalculeItems: (state) => {
      lazyLoadPicklistItems("baseCalcule", state, "baseCalcule", getBaseCalcule);
      return state.baseCalcule?.items ?? [];
  },
  termItems: (state) => {
      lazyLoadPicklistItems("term", state, "term", getTerm);
      return state.term?.items ?? [];
  },
  paymentDateItems: (state) => {
      lazyLoadPicklistItems("paymentDate", state, "paymentDate", getPaymentDate);
      return state.paymentDate?.items ?? [];
  },
  paymentFrequenceItems: (state) => {
      lazyLoadPicklistItems("paymentFrequence", state, "paymentFrequence", getPaymentFrequence);
      return state.paymentFrequence?.items ?? [];
  },
  currentStatusCodeItems: (state) => {
      lazyLoadPicklistItems("current_status_code", state, "current_status_code", getClientStatus);
      return state.current_status_code?.items ?? [];
  },
  activitySectorItems: (state) => {
      lazyLoadPicklistItems("activitySector", state, "activitySector", getActivitySector);
    if (state.activitySector?.items) {
      return translateComboBox(state.activitySector.items, 'picklists.activity.');
    } else {
      return [];
    }
  },
  legalCategoryItems: (state) => {
      lazyLoadPicklistItems("legalCategory", state, "legalCategory", getLegalCategory);
      if (state.legalCategory?.items) {
        return translateComboBox(state.legalCategory.items, 'picklists.legal-category.');
      } else {
        return [];
      }
  },
  relationsItems: (state) => {
      lazyLoadPicklistItems("relations", state, "relations", getRelations);
      return state.relations?.items ?? [];
  },
  relationTypeItems: (state) => {
      lazyLoadPicklistItems("relationType", state, "relationType", getRelationType);
      return state.relationType?.items ?? [];
  },
  countriesItems: (state) => {
    lazyLoadPicklistItems("countries", state, "countries", getCountries);
    return state.countries?.items ?? [];
  },
  postalCodesItems: (state) => {
    if (!state.postalCodes?.items?.length) {
      const cachedCountry = Object.keys(state.postalCodesFullByCountry ?? {})[0];
      const cached = cachedCountry
        ? state.postalCodesFullByCountry?.[cachedCountry]
        : undefined;
      if (cached?.length) {
        return cached;
      }
      if (!state.thirdEditPicklistsReady) {
        lazyLoadPicklistItems("postalCodes", state, "postalCodes", getPostalCodes);
      }
    }
    return state.postalCodes?.items ?? [];
  },
  addressTypeItems: (state) => {
    lazyLoadPicklistItems("addressType", state, "addressType", getAddressType);
    return state.addressType?.items ?? [];
  },
  addressPreferenceTypeItems: (state) => {
    lazyLoadPicklistItems("addressPreferenceType", state, "addressPreferenceType", getAddressPreferenceType);
    return state.addressPreferenceType?.items ?? [];
  },
  titlesItems: (state) => {
    lazyLoadPicklistItems("titles", state, "titles", getTitles);
    return state.titles?.items ?? [];
  },
  occupationItems: (state) => {
    lazyLoadPicklistItems("occupation", state, "occupation", getOccupation);
    return state.occupation?.items ?? [];
  },
  periodRateOptionItems: (state) => {
    lazyLoadPicklistItems("periodRateOption", state, "periodRateOption", getPeriodRateOption);
    return state.periodRateOption?.items ?? [];
  },
  warrantMethodItems: (state) => {
    lazyLoadPicklistItems("warrantMethod", state, "warrantMethod", getWarrantMethod);
    return state.warrantMethod?.items ?? [];
  },

  contactTypeItems: (state) => {
    lazyLoadPicklistItems("contactType", state, "contactType", getContactType);
    return state.contactType?.items ?? [];
  },
  idProofItems: (state) => {
    lazyLoadPicklistItems("IdProof", state, "IdProof", getIdProof);
    return state.IdProof?.items ?? [];
  },
  accountTypeItems: (state) => {
    lazyLoadPicklistItems("accountType", state, "accountType", getAccountType);
    return state.accountType?.items ?? [];
  },
  accountStatusItems: (state) => {
    lazyLoadPicklistItems("accountStatus", state, "accountStatus", getAccountStatus);
    return state.accountStatus?.items ?? [];
  },
  nationalityItems: (state) => {
    lazyLoadPicklistItems("nationality", state, "nationality", () => getNationality([]));
    return state.nationality?.items ?? [];
  },
  jobActivityItems: (state) => {
    lazyLoadPicklistItems("jobActivity", state, "jobActivity", getJobActivity);
    return state.jobActivity?.items ?? [];
  },
  jobPositionTypeItems: (state) => {
    lazyLoadPicklistItems("jobPositionType", state, "jobPositionType", getJobPositionType);
    return state.jobPositionType?.items ?? [];
  },
  periodicityItems: (state) => {
    lazyLoadPicklistItems("periodicity", state, "periodicity", getPeriodicity);
    return state.periodicity?.items ?? [];
  },
  partyRelationTypeItems: (state) => {
    lazyLoadPicklistItems("partyRelationType", state, "partyRelationType", getPartyRelationTypes);
    return state.partyRelationType?.items ?? [];
  },
  languageItems: (state) => {
    lazyLoadPicklistItems("language", state, "language", getLanguage);
    return state.language?.items ?? [];
  },
  bodyAssetItems: (state) => {
    lazyLoadPicklistItems("bodyAsset", state, "bodyAsset", getBodiesAsset);
    return state.bodyAsset?.items ?? [];
  },
  brandAssetItems: (state) => {
    lazyLoadPicklistItems("brandAsset", state, "brandAsset", getBrandsAsset);
    return state.brandAsset?.items ?? [];
  },

  modelAssetItems: (state) => {
    lazyLoadPicklistItems("modelAsset", state, "modelAsset", getModelsAsset);
    return state.modelAsset?.items ?? [];
  },
  finishingAssetItems: (state) => {
    lazyLoadPicklistItems("finishingAsset", state, "finishingAsset", getFinishesAsset);
    return state.finishingAsset?.items ?? [];
  },
  fuelTypeAssetItems: (state) => {
    lazyLoadPicklistItems("fuelTypeAsset", state, "fuelTypeAsset", getFuelTypesAsset);
    return state.fuelTypeAsset?.items ?? [];
  },
  emissionCO2AssetItems: (state) => {
    lazyLoadPicklistItems("emissionCO2Asset", state, "emissionCO2Asset", getEmissionsCO2Asset);
    return state.emissionCO2Asset?.items ?? [];
  },
  powerHPAssetItems: (state) => {
    lazyLoadPicklistItems("powerHPAsset", state, "powerHPAsset", getPowersHPAsset);
    return state.powerHPAsset?.items ?? [];
  },
  garantyRoleItems: (state) => {
    lazyLoadPicklistItems("garantyrole", state, "garantyrole", getGarantyRules);
    if(state.garantyrole?.items){
      return translateComboBox(state.garantyrole.items, 'demand.party.roles');
    } else {
      return [];
    }
  },
  roleStatusItems: (state) => {
    lazyLoadPicklistItems("roleStatus", state, "roleStatus", getRoleStatus);
    return state.roleStatus?.items ?? [];
  },
  natureBalanceSheetItems: (state) => {
    lazyLoadPicklistItems("natureBalanceSheet", state, "natureBalanceSheet", getNatureBalanceSheet);
    return state.natureBalanceSheet?.items ?? [];
  },
  decisionMotifItems: (state) => {
    lazyLoadPicklistItems("decisionMotif", state, "decisionMotif", getDecisionMotif);
    return state.decisionMotif?.items ?? [];
  },
  decisionreserveItems: (state) => {
    lazyLoadPicklistItems("decisionreserve", state, "decisionreserve", getDecisionReserve);
    return state.decisionreserve?.items ?? [];
  },
  decisionStatusItems: (state) => {
    lazyLoadPicklistItems("decisionStatus", state, "decisionStatus", getDecisionStatus);
    return state.decisionStatus?.items ?? [];
  },
  SupportingDocumentStatusItems: (state) => {
    lazyLoadPicklistItems("supportingDocumentStatus", state, "supportingDocumentStatus", getSupportingDocumentStatus);
    return state.supportingDocumentStatus?.items ?? [];
  },
  partyClassItems: (state) => {
    lazyLoadPicklistItems("partyClass", state, "partyClass", getPartyClass);
    if(state.partyClass?.items){
      return translateComboBox(state.partyClass.items, 'demand.party.partyClass');
    } else {
      return [];
    }
  },
  actionTypeItems: (state) => {
    lazyLoadPicklistItems("actionType", state, "actionType", getActionType);
    return state.actionType?.items ?? [];
  },
  orderTypeFinancingItems: (state) => {
    lazyLoadPicklistItems("orderTypeFinancing", state, "orderTypeFinancing", getOrderTypeFinancing);
    return state.orderTypeFinancing?.items ?? [];
  },
  netheosStatusOptions: () => [
      { label: '', value: '' },  // Empty option
      { label: '4 - traitment términe', value: '4' }
  ],
  thirdEditPicklistsReady: (state) => state.thirdEditPicklistsReady === true,
  getTemplateCodetems: (state) => {
    lazyLoadPicklistItems("templateCodeItems", state, "templateCodeItems", getTemplateCode);
    if (state.templateCodeItems?.items) {
        return state.templateCodeItems.items;
    } else {
      return [];
    }
  }
  

  },
  actions: {
    initializePicklists({ commit }) {
        attemptedLazyPicklists.clear();
        getPicklistInitialValues()
        .then((res) => {
          commit("setPicklistInitialValue", res);
        })
        .catch((e) => {  
          if(store.state.authModule?.user.loggedIn) {
            Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
              message: `Request returned an error \n ${e}`,
              color: "negative",
            });
          }        
        });
    
    },
    setNamesServices({ commit }, payload) {
      const { parentId } = payload;
      getNamesServices(parentId)
        .then((res) => {
          commit("setPickListNamesServicesValue", res);
        })
        .catch((e) => {
          Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
            message: `Request returned an error \n ${e}`,
            color: "negative",
          });
        });
    },
    async prefetchThirdEditScreenPicklists(
      { commit, dispatch, state },
      payload: { country_code?: string; isOrganization?: boolean }
    ) {
      if (state.thirdEditPicklistsReady) {
        return;
      }

      const country_code =
        payload?.country_code ||
        "FR";
      const isOrganization = !!payload?.isOrganization;

      try {
        const nationality = await getNationality("");
        commit("setPickListNationalityValue", nationality);

        await dispatch("prefetchPostalCodes", { country_code });

        const geographicZone = await getGeographicZone();
        commit("setPicklistComboValue", {
          field: "geographicZone",
          value: geographicZone,
        });

        if (isOrganization) {
          const legalCategory = await getLegalCategory();
          commit("setPicklistComboValue", {
            field: "legalCategory",
            value: legalCategory,
          });

          const codeNaceOptions = await getcodeNaceOptions();
          commit("setPicklistComboValue", {
            field: "codeNaceOptions",
            value: codeNaceOptions,
          });

          const activitySector = await getActivitySector();
          commit("setPicklistComboValue", {
            field: "activitySector",
            value: activitySector,
          });
        }

        commit("setThirdEditPicklistsReady", true);
      } catch (e) {
        Notify.create({
          timeout: 10000,
          actions: [{ icon: "close", color: "white" }],
          message: `Request returned an error \n ${e}`,
          color: "negative",
        });
        throw e;
      }
    },
    prefetchPostalCodes({ commit, state }, payload: { country_code?: string }) {
      const country_code = payload?.country_code || "FR";
      const cached = state.postalCodesFullByCountry?.[country_code];
      if (cached?.length) {
        commit("setPickListPostalCodeValue", {
          systemUid: ODM_PARTY,
          items: cached,
        });
        return Promise.resolve();
      }
      return getPostalCodes(country_code, "%%")
        .then((res) => {
          commit("setPostalCodesFullCache", {
            country_code,
            items: res.items ?? [],
          });
          commit("setPickListPostalCodeValue", res);
        })
        .catch((e) => {
          Notify.create({
            timeout: 10000,
            actions: [{ icon: "close", color: "white" }],
            message: `Request returned an error \n ${e}`,
            color: "negative",
          });
        });
    },
    applyPostalCodeQuery({ commit, state }, payload) {
      const country_code = payload?.country_code || "FR";
      const query = payload?.query;

      if (isUnfilteredPostalQuery(query)) {
        const cached = state.postalCodesFullByCountry?.[country_code];
        if (cached?.length) {
          commit("setPickListPostalCodeValue", {
            systemUid: ODM_PARTY,
            items: cached,
          });
          return Promise.resolve();
        }
      }

      return getPostalCodes(country_code, query)
        .then((res) => {
          if (isUnfilteredPostalQuery(query)) {
            commit("setPostalCodesFullCache", {
              country_code,
              items: res.items ?? [],
            });
          }
          commit("setPickListPostalCodeValue", res);
        })
        .catch((e) => {
          Notify.create({
            timeout: 10000,
            actions: [{ icon: "close", color: "white" }],
            message: `Request returned an error \n ${e}`,
            color: "negative",
          });
        });
    },
    applyNationalityQuery(_context, payload) {
      const { query , callback } = payload;
      getNationality(query)
        .then((res) => {
          callback(res);
        })
        .catch((e) => {
          Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
            message: `Request returned an error \n ${e}`,
            color: "negative",
          });
        });
    },
    applyJobOccupationQuery({ commit }, payload) {
      const { query , callback} = payload;
      getJobOccupationType(query)
        .then((res) => {
          commit("setPickListJobOccupationValue", res);
          callback(res);
        })
        .catch((e) => {
          Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
            message: `Request returned an error \n ${e}`,
            color: "negative",
          });
        });
    },
    applyAssetsQuery({ commit }, payload) {
      const { query } = payload;
      getAssetsMock(query)
        .then((res) => {
          commit("setPickListAssetsValue", res);
        })
        .catch((e) => {
          Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
            message: `Request returned an error \n ${e}`,
            color: "negative",
          });
        });
    },
    fetchReasonsByStatus({ commit }, payload) {
      fetchReasons(payload)
        .then(response => commit('setReasons', response))
        .catch((e) => logger.error(e));
    },
    populateScaleClassifications({ commit }, payload) {
      const { categoryId, callback } = payload;
      getScaleClassification(categoryId)
        .then(res => callback(res))
        .catch(err => logger.error(err));
    }
  },
  mutations: {
    async setPicklistInitialValue(state, payload) {
      for (const property in payload) {
        if (payload[property]?.items && Array.isArray(payload[property].items)) {
          payload[property].items = await Promise.resolve(payload[property].items.sort((a: any, b: any) => a.label?.localeCompare(b?.label)));
        }
      }
      state.term = payload.term;
      state.paymentDate = payload.paymentDate;
      state.paymentFrequence = payload.paymentFrequence;
      state.baseCalcule = payload.baseCalcule;
      state.typeService = payload.typeService;
      state.demandStatus = payload.demandStatus;
      state.brand = payload.brand;
      state.range = payload.range;
      state.clientType = payload.clientType;
      state.current_status_code = payload.current_status_code;
      state.network = payload.network;
      state.networkNode = payload.networkNode;
      state.role = payload.role;
      state.garantyrole = payload.garantyrole;
      state.activitySector = payload.activitySector;
      state.legalCategory = payload.legalCategory;
      state.relations = payload.relations;
      state.countries = payload.countries;
      state.geographicZone = payload.geographicZone;
      state.cities = payload.cities;
      state.postalCodes = payload.postalCodes;
      state.statusMarital = payload.statusMarital;
      state.matrimonialRegime = payload.matrimonialRegime;
      state.addressType = payload.addressType;
      state.addressPreferenceType = payload.addressPreferenceType;
      state.titles = payload.titles;
      state.occupation = payload.occupation;
      state.periodRateOption = payload.periodRateOption;
      state.warrantMethod = payload.warrantMethod;
      state.contactType = payload.contactType;
      state.IdProof = payload.IdProof;
      state.facilityType = payload.facilityType;
      state.qualificationType = payload.qualificationType;
      state.relationType = payload.relationType;
      state.accountType = payload.accountType;
      state.accountStatus = payload.accountStatus;
      state.natureBalanceSheet = payload.natureBalanceSheet;
      state.roleStatus = payload.roleStatus;
      state.partyClass = payload.partyClass;
      state.nationality = payload.nationality;
      state.jobActivity = payload.jobActivity;
      state.jobPositionType = payload.jobPositionType;
      state.jobOccupationType = payload.jobOccupationType;
      state.nature = payload.nature;
      state.periodicity = payload.periodicity;
      state.partyRelationType = payload.partyRelationType;
      state.language = payload.language
      state.partyClassificationType = payload.partyClassificationType
      state.gender = payload.gender
      state.contractType = payload.contractType
      state.propertyStatus = payload.propertyStatus
      state.documentType = payload.documentType
      state.codeNaceOptions = payload.codeNaceOptions
      state.signatureMethods = payload.signatureMethods
      //Asset
      state.categoryAsset = payload.categoryAsset;
      state.usageAsset = payload.usageAsset;
      state.colors = payload.colors;
      state.activity = payload.activity;
      state.bodyAsset = payload.bodyAsset;
      state.brandAsset = payload.brandAsset;
      state.modelAsset = payload.modelAsset;
      state.finishingAsset = payload.finishingAsset;
      state.fuelTypeAsset = payload.fuelTypeAsset;
      state.emissionCO2Asset = payload.emissionCO2Asset;
      state.powerHPAsset = payload.powerHPAsset;
      state.assets = payload.assets;
      state.typeCredits = payload.typeCredits;
      state.organization = payload.organization;
      state.objects = payload.objects;

      state.channel = payload.channel;
      //Task
      state.actionType = payload.actionType;
      state.module = payload.module
      //decision
      state.decisionMotif = payload.decisionMotif;
      state.decisionreserve = payload.decisionreserve;
      state.decisionStatus = payload.decisionStatus;
      state.decisionOpinion = payload.decisionOpinion;
      // Accept Offer
      state.acceptDecisionStatus = payload.acceptDecisionStatus;

      state.financialProfile = payload.financialProfile;
      state.scaleStatus = payload.scaleStatus;
      state.scaleCategory = payload.scaleCategory;
      state.productTax = payload.productTax;
      state.productTaxServices = payload.productTaxServices;
      state.scalefrequency = payload.scalefrequency;
      state.scaleRateBasis = payload.scaleRateBasis;
      state.scaleGracePeriodCalculationMethod = payload.scaleGracePeriodCalculationMethod;
      state.serviceType = payload.serviceType;
      state.productBasis = payload.productBasis;
      state.accessoryCalculationMethod = payload.accessoryCalculationMethod;
      state.accessoryPaymentDatesOption = payload.accessoryPaymentDatesOption;
      state.assetTypeItems = payload.assetTypeItems;
      state.assetStatut = payload.assetStatut;
      state.assetCatalog = payload.assetCatalog;

      //Garanty
      state.garantyStatus = payload.garantyStatus;
      state.garantyType = payload.garantyType;
      state.typeOutstanding = payload.typeOutstanding;
      state.financialInstitution = payload.financialInstitution;
      state.underlyingType = payload.underlyingType
      state.garantyBasis = payload.garantyBasis;

      state.productAvailabilityContext = payload.productAvailabilityContext;

      // order
      state.orderStatus = payload.orderStatus;
      state.orderItemStatus = payload.orderItemStatus;
      state.orderTypeFinancing = payload.orderTypeFinancing;
      state.orderServiceType=payload.orderServiceType

      state.delegationLevels = payload.delegationLevels;

      state.justifyTypes = payload.justifyTypes;
      state.supportingDocumentType = payload.supportingDocumentType;
      state.roleOrder = payload.roleOrder;
      // User
      state.userSecurityGroup = payload.userSecurityGroup;
      state.userTeam = payload.userTeam;
      state.userNetwork = payload.userNetwork;
      state.userNetworkNode = payload.userNetworkNode;
      state.netheosStatus = payload.netheosStatus;
    },
    setPickListFinancingProduct(state, payload) {
      state.financingProduct = payload;
    },
    setPickListNamesServicesValue(state, payload) {
      state.namesServices = payload;
    },
    setPickListPostalCodeValue(state, payload) {
      state.postalCodes = payload;
    },
    setPostalCodesFullCache(
      state,
      payload: { country_code: string; items: any[] }
    ) {
      if (!state.postalCodesFullByCountry) {
        state.postalCodesFullByCountry = {};
      }
      state.postalCodesFullByCountry[payload.country_code] = payload.items;
    },
    setPicklistComboValue(
      state,
      payload: { field: keyof PicklistState; value: any }
    ) {
      (state as Record<string, unknown>)[payload.field as string] = payload.value;
    },
    setThirdEditPicklistsReady(state, ready: boolean) {
      state.thirdEditPicklistsReady = ready;
    },
    setPickListNationalityValue(state, payload) {
      state.nationality = payload;
    },
    setPickListJobOccupationValue(state, payload) {
      state.jobOccupationType = payload;
    },
    setPickListAssetsValue(state, payload) {
      state.assets = payload;
    },
    setReasons(state, payload) {
      const list = Array.isArray(payload) ? payload : payload?.items ?? [];
      state.reasons = {
        items: list.map((item: any) => {
          const id = item.resourceUid ?? item.id;
          const taskKey = `task.reasons.${id}`;
          const label = i18n.global.te(taskKey)
            ? i18n.global.t(taskKey)
            : (item.label ?? item.name ?? item.internalCode ?? id);
          return {
            value: id,
            label,
          };
        }),
      };
    }
  },
};

export default picklistModule;
